import React, {useCallback, useMemo, memo} from 'react';
import PropTypes from 'prop-types';
import {connect, useDispatch} from 'react-redux';
import {ActionToggleInfoBar} from '../../../store/actions/actions-pages';

function HeaderInfoBtn({hideInfoBar}) {
  const dispatch = useDispatch();

  const getIcon = useMemo(() => {
    if (hideInfoBar) {
      return (
        <svg
          id="eckx4b1asst1"
          width="44"
          height="44"
          viewBox="0 0 44 44"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        >
          <g id="eckx4b1asst2">
            <g id="eckx4b1asst3" transform="matrix(1 0 0 1 -124 -91)">
              <g id="eckx4b1asst4" transform="matrix(1 0 0 1 124 91)">
                <g id="info-button-layer1" transform="translate(22,22) scale(0.500000,0.500000)">
                  <path
                    id="info-button-layer2"
                    d="M22,12.571429C16.800143,12.571429,12.571429,16.800143,12.571429,22C12.571429,27.199857,16.800143,31.428571,22,31.428571C27.199857,31.428571,31.428571,27.199857,31.428571,22C31.428571,16.800143,27.199857,12.571429,22,12.571429M22,33C15.934286,33,11,28.065714,11,22C11,15.934286,15.934286,11,22,11C28.065714,11,33,15.934286,33,22C33,28.065714,28.065714,33,22,33"
                    transform="translate(-22,-22)"
                    opacity="0"
                    fill="rgb(18,135,251)"
                    fillRule="evenodd"
                    stroke="none"
                    strokeWidth="1"
                  />
                </g>
                <polygon
                  id="info-button-layer3"
                  points="21.214286,18.459143 23.214286,18.459143 23.214286,16.459143 21.214286,16.459143"
                  transform="matrix(1 0 0 1 -0.21428570000000 -0.45914290000000)"
                  opacity="0"
                  fill="rgb(18,135,251)"
                  fillRule="evenodd"
                  stroke="none"
                  strokeWidth="1"
                  strokeOpacity="0"
                />
                <g id="info-button-layer4" transform="translate(22,22)">
                  <g id="info-button-layer5" transform="rotate(-45)">
                    <g id="info-button-layer6" transform="scale(1,2.500000)">
                      <polygon
                        id="eckx4b1asst8"
                        points="21.214286,27.682143 23.214286,27.682143 23.214286,19.682143 21.214286,19.682143"
                        transform="translate(-22.214286,-23.682143)"
                        fill="rgb(18,135,251)"
                        fillRule="evenodd"
                        stroke="none"
                        strokeWidth="1"
                      />
                    </g>
                  </g>
                </g>
                <g id="info-button-layer7" transform="translate(22,22)">
                  <g id="info-button-layer8" transform="rotate(45)">
                    <g id="info-button-layer9" transform="scale(1,2.500000)">
                      <polygon
                        id="eckx4b1asst9"
                        points="21.214286,27.682143 23.214286,27.682143 23.214286,19.682143 21.214286,19.682143"
                        transform="translate(-22.214286,-23.682143)"
                        fill="rgb(18,135,251)"
                        fillRule="evenodd"
                        stroke="none"
                        strokeWidth="1"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      );
    }
    return (
      <svg
        id="e1gafuvhoeqa1"
        width="44"
        height="44"
        viewBox="0 0 44 44"
        shapeRendering="geometricPrecision"
        textRendering="geometricPrecision"
      >
        <g id="e1gafuvhoeqa2">
          <g id="e1gafuvhoeqa3" transform="matrix(1 0 0 1 -124 -91)">
            <g id="e1gafuvhoeqa4" transform="matrix(1 0 0 1 124 91)">
              <rect
                id="e1gafuvhoeqa5"
                width="44"
                height="44"
                rx="8"
                ry="0"
                opacity="0.1"
                fill="rgb(18,135,251)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
              />
              <g id="info-button-layer10" transform="translate(22,22) scale(1,1)">
                <path
                  id="info-button-layer11"
                  d="M22,12.571429C16.800143,12.571429,12.571429,16.800143,12.571429,22C12.571429,27.199857,16.800143,31.428571,22,31.428571C27.199857,31.428571,31.428571,27.199857,31.428571,22C31.428571,16.800143,27.199857,12.571429,22,12.571429M22,33C15.934286,33,11,28.065714,11,22C11,15.934286,15.934286,11,22,11C28.065714,11,33,15.934286,33,22C33,28.065714,28.065714,33,22,33"
                  transform="translate(-22,-22)"
                  fill="rgb(18,135,251)"
                  fillRule="evenodd"
                  stroke="none"
                  strokeWidth="1"
                />
              </g>
              <polygon
                id="info-button-layer12"
                points="21.214286,18.459143 23.214286,18.459143 23.214286,16.459143 21.214286,16.459143"
                transform="matrix(1 0 0 1 -0.21428570000000 -0.45914290000000)"
                fill="rgb(18,135,251)"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
                strokeOpacity="0"
              />
              <g id="info-button-layer13" transform="translate(22,24)">
                <g id="info-button-layer14" transform="rotate(0)">
                  <g id="info-button-layer15" transform="scale(1,1)">
                    <polygon
                      id="e1gafuvhoeqa8"
                      points="21.214286,27.682143 23.214286,27.682143 23.214286,19.682143 21.214286,19.682143"
                      transform="translate(-22.214286,-23.682143)"
                      fill="rgb(18,135,251)"
                      fillRule="evenodd"
                      stroke="none"
                      strokeWidth="1"
                    />
                  </g>
                </g>
              </g>
              <g id="info-button-layer16" transform="translate(22,24)">
                <g id="info-button-layer17" transform="rotate(0)">
                  <g id="info-button-layer18" transform="scale(1,1)">
                    <polygon
                      id="e1gafuvhoeqa9"
                      points="21.214286,27.682143 23.214286,27.682143 23.214286,19.682143 21.214286,19.682143"
                      transform="translate(-22.214286,-23.682143)"
                      fill="rgb(18,135,251)"
                      fillRule="evenodd"
                      stroke="none"
                      strokeWidth="1"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }, [hideInfoBar]);

  const onClickBtn = useCallback(() => {
    dispatch(ActionToggleInfoBar());
  }, [hideInfoBar]);

  return (
    <div className="header-info-btn" onClick={onClickBtn} role="button">
      {getIcon}
    </div>
  );
}

HeaderInfoBtn.defaultProps = {
  hideInfoBar: true,
};

HeaderInfoBtn.propTypes = {
  hideInfoBar: PropTypes.bool,
};

function mapStateToProps({rPages}) {
  return {
    hideInfoBar: rPages.hideInfoBar,
  };
}
export default connect(mapStateToProps, null)(memo(HeaderInfoBtn));
